import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'vectronic-details-item',
  templateUrl: './details-item.component.html',
  styleUrls: ['./details-item.component.scss'],
  imports: [CommonModule, MatIcon, MatTooltip],
})
export class DetailsItemComponent {
  header = input<string>();
  isSmall = input(false);
  isInLine = input(false);
  tooltip = input<string>();
}
